import { Checkbox, FormControlLabel, Grid, Tooltip } from "@mui/material";
import theme from "Theme/AppTheme";
import AcxToggleButton from "components/UI/AcxToggleButton";
import { observer } from "mobx-react";
import { RenderModeType } from "components/Signals/SignalsModels";
import type ChartCardStore from "../ChartCardStore";

type ComparePrevAndRenderModeControlsProps = {
    store: ChartCardStore;
    showComparePrevCheckbox: boolean;
    showPercentToggle: boolean;
};

const ComparePrevAndRenderModeControls = observer(
    ({
        store,
        showComparePrevCheckbox,
        showPercentToggle,
    }: ComparePrevAndRenderModeControlsProps) => {
        const comparePrevTooltipText = store.comparePrevDates
            ? `Previous Period: ${store.comparePrevDates.compareStart.format(
                  "MM/DD/YY",
              )} - ${store.comparePrevDates.compareEnd.format("MM/DD/YY")}`
            : "Compare to previous period";
        // Compare previous is disabled once grouping is configured because the backend
        // grouping payload and compare-period payload are treated as separate modes.
        const comparePrevDisabledReason =
            store.groupingStore.isGrouped && !store.comparePrevEnabled
                ? "Disable grouping to enable compare previous"
                : undefined;

        return (
            <Grid
                container
                item
                xs="auto"
                justifyContent="flex-end"
                alignItems="center"
                sx={{ marginLeft: "auto" }}
            >
                {showComparePrevCheckbox && (
                    <Grid item>
                        <Tooltip
                            title={
                                comparePrevDisabledReason ??
                                comparePrevTooltipText
                            }
                        >
                            <span>
                                <FormControlLabel
                                    id={
                                        "compare-to-previous-period-" + store.id
                                    }
                                    label={
                                        <Grid container alignItems="center">
                                            Compare to previous period
                                        </Grid>
                                    }
                                    control={
                                        <Checkbox
                                            onChange={() => {
                                                store.toggleComparePrevious();
                                            }}
                                            checked={store.comparePrevEnabled}
                                            disabled={
                                                !!comparePrevDisabledReason
                                            }
                                        />
                                    }
                                />
                            </span>
                        </Tooltip>
                    </Grid>
                )}
                {showPercentToggle && (
                    <AcxToggleButton
                        id={`${store.id}-Percent-Count-Toggle`}
                        items={["%", "#"]}
                        shrink
                        onChange={() => {
                            store.toggleRenderMode();
                        }}
                        exclusive
                        defaultValue={
                            store.currentRenderMode === RenderModeType.Count
                                ? "#"
                                : "%"
                        }
                        style={{
                            height: "36px",
                            marginLeft: theme.spacing(1),
                        }}
                    />
                )}
            </Grid>
        );
    },
);

export default ComparePrevAndRenderModeControls;
